"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = {
    All: 'All',
    SMARTTAG: 'SMART_TAG',
    LOCATIONCALIBRATION: 'LOCATION_CALIBRATION',
    UNKNOWN: 'UNKNOWN'
};
//# sourceMappingURL=deviceType.js.map